import { useRive } from '@rive-app/react-canvas'
import { useCallback, useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

import riveEmail from './assets/email.riv?url'
import riveNotification from './assets/notification.riv?url'
import riveUpdate from './assets/update.riv?url'

export const Slideshow = () => {
  const [current, setCurrent] = useState(0)
  const [isHidden, setIsHidden] = useState(false)

  const next = useCallback(() => {
    setIsHidden(true)

    setTimeout(() => {
      setIsHidden(false)
      setCurrent((prev) => (prev + 1) % 3)
    }, 500)
  }, [])

  return (
    <div className={cn('relative h-[500px] w-[500px]', 'transition-opacity duration-500', isHidden && 'opacity-0')}>
      {current === 0 && <Slide src={riveEmail} onComplete={next} />}
      {current === 1 && <Slide src={riveNotification} onComplete={next} />}
      {current === 2 && <Slide src={riveUpdate} onComplete={next} />}
    </div>
  )
}

const Slide = (props: { src: string; onComplete: () => void }) => {
  const { RiveComponent } = useRive({ src: props.src, autoplay: true })

  useEffect(() => {
    const timeout = setTimeout(() => {
      props.onComplete()
    }, 4000)

    return () => clearTimeout(timeout)
  }, [props])

  return <RiveComponent className={cn('absolute inset-0', 'animate-fade-in duration-500')} />
}
